<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="3" class="d-none d-md-flex">
                <TableCategory />
            </v-col>
            <v-col cols="12" md="9">
                <v-row>
                    <v-col cols="6" md="3" v-for="(value, index) in $store.state.category" v-bind:key="'CardCategory'+index">
                        <v-card class="card-category">
                            <router-link :to="{ name: 'Category', params: { id: value.id }}">
                                <v-img aspect-ratio="1" :src="value.image"></v-img>
                            </router-link>
                            <v-card-text class="pa-2">
                                <router-link :to="{ name: 'Category', params: { id: value.id }}">
                                    <div class="font-weight-bold text-h6">{{value.name}}</div>
                                    <div>{{value.subname}}</div>
                                </router-link>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import TableCategory from '@/components/TableCategory.vue';
    export default {
        components: {
            TableCategory
        },
    }
</script>